



// import React, { useEffect, useState, useMemo } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { supabase } from '../lib/supabase';
// import { Household, Transaction, GroupGuest } from '../types';
// import { format, subMonths, startOfMonth, endOfMonth, isWithinInterval } from 'date-fns';
// import { 
//   ChevronLeft, 
//   User as UserIcon,
//   Calendar,
//   Users,
//   ArrowRight,
//   FileText,
//   Scale,
//   ShieldCheck,
//   Filter,
//   Plus,
//   Trash2,
//   UserCircle,
//   AlertTriangle,
//   Clock,
//   ArrowUpRight,
//   ArrowDownRight
// } from 'lucide-react';
// import { generateGroupSettlementPDF } from '../services/pdfService';

// interface Settlement {
//   from: string;
//   to: string;
//   amount: number;
// }

// const GroupDetail: React.FC = () => {
//   const { id } = useParams<{ id: string }>();
//   const navigate = useNavigate();
  
//   const [group, setGroup] = useState<Household | null>(null);
//   const [allTransactions, setAllTransactions] = useState<Transaction[]>([]);
//   const [userMap, setUserMap] = useState<Record<string, string>>({});
//   const [loading, setLoading] = useState(true);
//   const [memberIds, setMemberIds] = useState<string[]>([]);
//   const [guests, setGuests] = useState<GroupGuest[]>([]);
//   const [showGuestManager, setShowGuestManager] = useState(false);
//   const [newGuestName, setNewGuestName] = useState('');
  
//   const [selectedMonth, setSelectedMonth] = useState<string>(format(new Date(), 'yyyy-MM'));
//   const [isAllTime, setIsAllTime] = useState(false);

//   useEffect(() => {
//     if (id) fetchData();
//   }, [id]);

//   const fetchData = async () => {
//     setLoading(true);
//     try {
//       const { data: household } = await supabase.from('households').select('*').eq('id', id).single();
//       if (!household) {
//         navigate('/groups');
//         return;
//       }
//       setGroup(household);

//       const { data: guestData } = await supabase.from('group_guests').select('*').eq('household_id', id);
//       setGuests(guestData || []);

//       const { data: memberRecords } = await supabase.from('household_members').select('user_id').eq('household_id', id);
//       const memberIdsFromTable = (memberRecords || []).map(m => m.user_id);

//       const { data: txs } = await supabase
//         .from('transactions')
//         .select('*')
//         .eq('household_id', id)
//         .order('date', { ascending: false });

//       const txList = (txs || []) as Transaction[];
//       setAllTransactions(txList);

//       const usersInTransactions = Array.from(new Set(txList.map(t => t.user_id)));
//       const combinedMemberIds = Array.from(new Set([...memberIdsFromTable, ...usersInTransactions]));
//       setMemberIds(combinedMemberIds);

//       const { data: profiles } = await supabase.from('user_profiles').select('id, display_name').in('id', combinedMemberIds);
//       const names: Record<string, string> = {};
//       profiles?.forEach(p => { names[p.id] = p.display_name || 'Member'; });
//       combinedMemberIds.forEach(uid => { if (!names[uid]) names[uid] = `User ${uid.substring(0, 4)}`; });
      
//       guestData?.forEach(g => { names[g.id] = g.name; });
//       setUserMap(names);
      
//     } catch (e) {
//       console.error("Fetch Data Error:", e);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const addGuest = async () => {
//     if (!newGuestName.trim() || !id) return;
//     const { data, error } = await supabase.from('group_guests').insert([{ household_id: id, name: newGuestName.trim() }]).select().single();
//     if (!error && data) {
//       setGuests([...guests, data]);
//       setUserMap({ ...userMap, [data.id]: data.name });
//       setNewGuestName('');
//       await fetchData();
//     }
//   };

//   const removeGuest = async (guestId: string) => {
//     const guest = guests.find(g => g.id === guestId);
//     if (!window.confirm(`Permanently remove "${guest?.name}"? Their financial history will be marked as 'Unassigned' but group totals will remain accurate.`)) return;
    
//     const { error } = await supabase.from('group_guests').delete().eq('id', guestId);
//     if (!error) {
//       await fetchData();
//     } else {
//       alert("Removal failed: " + error.message);
//     }
//   };

//   const filteredTransactions = useMemo(() => {
//     if (isAllTime) return allTransactions;
//     const start = startOfMonth(new Date(selectedMonth + '-01'));
//     const end = endOfMonth(new Date(selectedMonth + '-01'));
//     return allTransactions.filter(t => {
//       const txDate = new Date(t.date);
//       return isWithinInterval(txDate, { start, end });
//     });
//   }, [allTransactions, selectedMonth, isAllTime]);

//   const stats = useMemo(() => {
//     let total = 0;
//     const allPayerIds = Array.from(new Set([
//       ...memberIds,
//       ...guests.map(g => g.id)
//     ]));
    
//     const contributions: Record<string, number> = {};
//     allPayerIds.forEach(pid => contributions[pid] = 0);
    
//     filteredTransactions.forEach(t => {
//       if (t.type === 'expense' || t.type === 'debt') {
//         const amount = Number(t.amount);
//         total += amount;
//         const payerId = t.payer_guest_id || t.user_id;
//         if (payerId) {
//           contributions[payerId] = (contributions[payerId] || 0) + amount;
//         }
//       }
//     });

//     const share = allPayerIds.length > 0 ? total / allPayerIds.length : 0;
    
//     const balances = allPayerIds.map(pid => ({
//       pid,
//       name: userMap[pid] || 'Unassigned Member',
//       balance: (contributions[pid] || 0) - share
//     }));

//     const creditors = balances.filter(b => b.balance > 0.01).sort((a, b) => b.balance - a.balance);
//     const debtors = balances.filter(b => b.balance < -0.01).sort((a, b) => a.balance - b.balance);

//     const settlements: Settlement[] = [];
//     let i = 0, j = 0;
//     const creditorsCopy = creditors.map(c => ({ ...c }));
//     const debtorsCopy = debtors.map(d => ({ ...d }));

//     while (i < debtorsCopy.length && j < creditorsCopy.length) {
//       const debtAmount = Math.abs(debtorsCopy[i].balance);
//       const creditAmount = creditorsCopy[j].balance;
//       const settlementAmount = Math.min(debtAmount, creditAmount);
      
//       if (settlementAmount > 0.01) {
//         settlements.push({
//           from: debtorsCopy[i].name,
//           to: creditorsCopy[j].name,
//           amount: Math.round(settlementAmount * 100) / 100
//         });
//       }
      
//       debtorsCopy[i].balance += settlementAmount;
//       creditorsCopy[j].balance -= settlementAmount;
//       if (Math.abs(debtorsCopy[i].balance) < 0.01) i++;
//       if (Math.abs(creditorsCopy[j].balance) < 0.01) j++;
//     }

//     return { total, contributions, settlements, share, allPayerIds };
//   }, [filteredTransactions, memberIds, guests, userMap]);

//   if (loading) return <div className="pt-20 text-center"><div className="animate-spin h-10 w-10 border-b-2 border-slate-900 mx-auto rounded-full"></div></div>;

//   return (
//     <div className="space-y-6 pb-20">
//       <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
//         <div className="flex items-center gap-4">
//           <button onClick={() => navigate('/groups')} className="p-3 bg-white border border-slate-100 rounded-2xl text-slate-400 hover:text-slate-900 shadow-sm transition-all"><ChevronLeft size={20} /></button>
//           <div>
//             <h1 className="text-2xl font-black text-slate-900 leading-none">{group?.name}</h1>
//             <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mt-2">Treasury Oversight</p>
//           </div>
//         </div>
//         <div className="flex gap-3">
//           <button onClick={() => setShowGuestManager(!showGuestManager)} className={`flex-1 md:flex-none p-4 rounded-2xl border transition-all flex items-center justify-center gap-2 ${showGuestManager ? 'bg-[#0f172a] text-[#fbbf24]' : 'bg-white text-slate-600 border-slate-100'}`}>
//             <UserCircle size={18} />
//             <span className="font-black text-[10px] uppercase tracking-widest">Guest Ledger</span>
//           </button>
//           <button onClick={() => generateGroupSettlementPDF(group!.name, stats.total, stats.allPayerIds.length, stats.contributions, userMap, stats.settlements, filteredTransactions).save('Report.pdf')} className="flex-1 md:flex-none bg-[#0f172a] text-[#fbbf24] p-4 rounded-2xl shadow-lg flex items-center justify-center gap-2 border border-white/5"><FileText size={18} /><span className="font-black text-[10px] uppercase tracking-widest">Statement</span></button>
//         </div>
//       </div>

//       {showGuestManager && (
//         <div className="bg-white p-8 rounded-[3rem] border-2 border-slate-100 shadow-2xl animate-in slide-in-from-top duration-300">
//            <h3 className="text-xs font-black text-slate-900 uppercase tracking-widest mb-6 flex items-center"><Users className="mr-2 text-amber-500" size={16} /> Roommate Registry</h3>
//            <div className="space-y-4">
//               <div className="flex flex-col sm:flex-row gap-3">
//                 <input type="text" placeholder="Alias (e.g. Person C)" className="flex-1 px-6 py-4 bg-slate-50 border border-slate-100 rounded-2xl outline-none font-bold text-sm" value={newGuestName} onChange={e => setNewGuestName(e.target.value)} />
//                 <button onClick={addGuest} className="bg-[#0f172a] text-amber-400 px-6 py-4 sm:py-0 rounded-2xl font-black text-[10px] uppercase tracking-widest flex items-center justify-center gap-2 transition-all active:scale-95"><Plus size={16} /> Enroll</button>
//               </div>
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-4">
//                 {guests.map(g => (
//                   <div key={g.id} className="flex items-center justify-between p-4 bg-slate-50 rounded-2xl border border-slate-100 group hover:border-slate-300 transition-all">
//                     <span className="font-bold text-slate-700 text-sm">{g.name}</span>
//                     <button 
//                       onClick={() => removeGuest(g.id)} 
//                       className="text-slate-300 hover:text-red-500 hover:bg-red-50 p-2.5 rounded-xl transition-all"
//                       title="Remove Member"
//                     >
//                       <Trash2 size={16} />
//                     </button>
//                   </div>
//                 ))}
//                 {guests.length === 0 && (
//                   <div className="col-span-2 py-8 text-center bg-slate-50/50 rounded-3xl border border-dashed border-slate-200">
//                     <p className="text-[9px] font-black text-slate-300 uppercase tracking-widest">No Virtual Members Enrolled</p>
//                   </div>
//                 )}
//               </div>
//            </div>
//            <div className="mt-6 flex items-center gap-3 bg-amber-50 p-4 rounded-2xl border border-amber-100">
//               <AlertTriangle className="text-amber-600 shrink-0" size={16} />
//               <p className="text-[9px] font-bold text-amber-700 uppercase tracking-wider leading-relaxed">
//                 Deleting a member recalculates the "Fair Share" for the remaining group. Any payments they made will be kept but unassigned.
//               </p>
//            </div>
//         </div>
//       )}

//       <div className="bg-white p-4 rounded-[2rem] border border-slate-100 shadow-sm flex flex-col sm:flex-row items-center gap-4">
//         <div className="flex items-center gap-3 bg-slate-50 p-1.5 rounded-2xl border border-slate-100 flex-1 w-full">
//           <button onClick={() => setIsAllTime(false)} className={`flex-1 py-2.5 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${!isAllTime ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-400'}`}>Monthly</button>
//           <button onClick={() => setIsAllTime(true)} className={`flex-1 py-2.5 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${isAllTime ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-400'}`}>All Time</button>
//         </div>
//         {!isAllTime && (
//           <div className="relative w-full sm:w-64">
//             <Calendar className="absolute left-5 top-1/2 -translate-y-1/2 text-slate-300" size={16} />
//             <select value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)} className="w-full pl-12 pr-6 py-4 bg-slate-50 border border-slate-100 rounded-2xl outline-none font-black text-[10px] uppercase tracking-widest appearance-none cursor-pointer">
//               {Array.from({ length: 12 }).map((_, i) => { 
//                 const d = subMonths(new Date(), i); 
//                 return <option key={i} value={format(d, 'yyyy-MM')}>{format(d, 'MMMM yyyy')}</option>; 
//               })}
//             </select>
//           </div>
//         )}
//       </div>

//       <div className="bg-[#0f172a] p-8 rounded-[3rem] text-white shadow-2xl relative overflow-hidden border border-white/5">
//         <div className="absolute top-0 right-0 w-48 h-48 bg-amber-400/10 blur-[60px] -translate-y-1/2 translate-x-1/2"></div>
//         <div className="relative z-10 flex flex-col md:flex-row md:items-center justify-between gap-6">
//           <div>
//             <p className="text-[10px] font-black uppercase opacity-60 tracking-[0.2em]">{isAllTime ? 'Total Group Spend' : `Spend for ${format(new Date(selectedMonth + '-01'), 'MMMM yyyy')}`}</p>
//             <p className="text-4xl font-black text-amber-400 mt-2">₹{stats.total.toLocaleString()}</p>
//             <div className="mt-4 flex flex-wrap gap-4">
//                <div className="flex items-center gap-2"><Users size={12} className="text-slate-400" /><span className="text-[9px] font-bold text-slate-400 uppercase tracking-widest">{stats.participatingCount} In Split / {stats.allPayerIds.length} Total</span></div>
//                <div className="flex items-center gap-2"><Scale size={12} className="text-amber-400" /><span className="text-[9px] font-black text-amber-400 uppercase tracking-widest">Fair Share: ₹{Math.round(stats.share).toLocaleString()}</span></div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <section className="space-y-4">
//         <h3 className="text-xs font-black text-slate-900 uppercase tracking-widest flex items-center px-2"><Scale size={14} className="mr-2 text-amber-500" /> Settle-Up Logic</h3>
//         <div className="bg-amber-50/50 rounded-[2.5rem] border border-amber-100 p-6 space-y-3">
//           {stats.settlements.length > 0 ? (
//             stats.settlements.map((s, idx) => (
//               <div key={idx} className="bg-white p-5 rounded-2xl border border-amber-100 flex items-center justify-between shadow-sm">
//                 <div className="flex items-center gap-4">
//                   <div className="text-center min-w-[70px]"><p className="font-black text-slate-900 text-xs">{s.from}</p><p className="text-[7px] font-black text-red-400 uppercase tracking-widest">Owes</p></div>
//                   <ArrowRight size={14} className="text-amber-400" />
//                   <div className="text-center min-w-[70px]"><p className="font-black text-slate-900 text-xs">{s.to}</p><p className="text-[7px] font-black text-emerald-500 uppercase tracking-widest">To Collect</p></div>
//                 </div>
//                 <p className="font-black text-amber-600 text-lg">₹{s.amount.toLocaleString()}</p>
//               </div>
//             ))
//           ) : (
//             <div className="text-center py-10"><ShieldCheck size={20} className="text-emerald-600 mx-auto mb-4" /><p className="text-[10px] font-black text-emerald-700 uppercase tracking-widest">Equilibrium Reached</p></div>
//           )}
//         </div>
//       </section>

//       <section className="space-y-4">
//         <h3 className="text-xs font-black text-slate-900 uppercase tracking-widest flex items-center px-2"><Filter size={14} className="mr-2 text-slate-400" /> Member Balance Sheets</h3>
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
//           {stats.allPayerIds.map((pid) => {
//             const amount = stats.contributions[pid] || 0;
//             const balance = amount - stats.share;
//             return (
//               <div key={pid} className="bg-white p-6 rounded-[2rem] border border-slate-100 shadow-sm flex items-center justify-between transition-all hover:border-slate-300">
//                 <div className="flex items-center"><div className="w-10 h-10 rounded-2xl bg-slate-50 flex items-center justify-center mr-4"><UserIcon size={18} className="text-[#0f172a]" /></div><div><p className="font-black text-slate-900 text-xs">{userMap[pid]}</p><p className="text-[8px] font-black text-slate-400 uppercase tracking-widest">Paid: ₹{amount.toLocaleString()}</p></div></div>
//                 <div className="text-right"><p className={`font-black text-xs ${balance >= 0 ? 'text-emerald-600' : 'text-red-600'}`}>{balance >= 0 ? '+' : '-'}₹{Math.abs(balance).toLocaleString()}</p></div>
//               </div>
//             );
//           })}
//         </div>
//       </section>

//       <section className="space-y-4">
//         <h3 className="text-xs font-black text-slate-900 uppercase tracking-widest flex items-center px-2"><Clock size={14} className="mr-2 text-slate-400" /> Transaction Stream</h3>
//         <div className="space-y-3">
//           {filteredTransactions.map(tx => (
//             <div key={tx.id} onClick={() => navigate(`/edit/${tx.id}`)} className="bg-white p-5 rounded-[2rem] border border-slate-100 flex items-center justify-between group transition-all hover:border-slate-300 cursor-pointer active:scale-[0.99]">
//               <div className="flex items-center">
//                 <div className={`w-12 h-12 rounded-2xl flex items-center justify-center mr-4 ${tx.type === 'expense' || tx.type === 'debt' ? 'bg-red-50 text-red-500' : 'bg-emerald-50 text-emerald-600'}`}>
//                   {tx.type === 'expense' || tx.type === 'debt' ? <ArrowDownRight size={20} /> : <ArrowUpRight size={20} />}
//                 </div>
//                 <div>
//                   <p className="font-black text-slate-900 text-sm leading-tight">{tx.category}</p>
//                   <p className="text-[9px] text-slate-400 font-black uppercase tracking-widest mt-1">
//                     {userMap[tx.payer_guest_id || tx.user_id] || 'Member'} • {format(new Date(tx.date), 'dd MMM')}
//                   </p>
//                 </div>
//               </div>
//               <p className={`font-black text-base ${tx.type === 'expense' || tx.type === 'debt' ? 'text-red-600' : 'text-emerald-700'}`}>
//                 ₹{Number(tx.amount).toLocaleString()}
//               </p>
//             </div>
//           ))}
//           {filteredTransactions.length === 0 && (
//             <div className="text-center py-10 bg-white rounded-[2rem] border border-dashed border-slate-200">
//                <p className="text-[9px] font-black text-slate-300 uppercase tracking-widest">No group entries for this period</p>
//             </div>
//           )}
//         </div>
//       </section>
//     </div>
//   );
// };

// export default GroupDetail;





// Add missing React hook imports
import React, { useState, useEffect, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { Household, Transaction, GroupGuest, GroupMemberExclusion } from '../types';
import { format, subMonths, startOfMonth, endOfMonth, isWithinInterval } from 'date-fns';
import { 
  ChevronLeft, 
  User as UserIcon,
  Calendar,
  Users,
  ArrowRight,
  FileText,
  Scale,
  ShieldCheck,
  Filter,
  Plus,
  Trash2,
  UserCircle,
  AlertTriangle,
  Clock,
  ArrowUpRight,
  ArrowDownRight,
  UserX,
  UserCheck,
  ToggleLeft as ToggleOff,
  ToggleRight as ToggleOn
} from 'lucide-react';
import { generateGroupSettlementPDF, saveSecurePDF } from '../services/pdfService';

interface Settlement {
  from: string;
  to: string;
  amount: number;
}

interface MonthlyBreakdown {
  monthKey: string | null;
  total: number;
  contributions: Record<string, number>;
  settlements: Settlement[];
  share: number;
  participatingCount: number;
  currentMonthExclusions: string[];
  allPayerIds: string[];
}

const GroupDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  
  const [group, setGroup] = useState<Household | null>(null);
  const [allTransactions, setAllTransactions] = useState<Transaction[]>([]);
  const [userMap, setUserMap] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(true);
  const [memberIds, setMemberIds] = useState<string[]>([]);
  const [guests, setGuests] = useState<GroupGuest[]>([]);
  const [exclusions, setExclusions] = useState<GroupMemberExclusion[]>([]);
  const [showGuestManager, setShowGuestManager] = useState(false);
  const [newGuestName, setNewGuestName] = useState('');
  
  const [selectedMonth, setSelectedMonth] = useState<string>(format(new Date(), 'yyyy-MM'));
  const [isAllTime, setIsAllTime] = useState(false);
  const [userPin, setUserPin] = useState<string | null>(null);

  useEffect(() => {
    if (id) {
      fetchData();
      fetchUserPin();
    }
  }, [id]);

  const fetchUserPin = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;
    const { data } = await supabase.from('user_profiles').select('pin, pdf_pin').eq('id', user.id).single();
    if (data) {
      setUserPin(data.pdf_pin || data.pin || null);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data: household } = await supabase.from('households').select('*').eq('id', id).single();
      if (!household) {
        navigate('/groups');
        return;
      }
      setGroup(household);

      const { data: exclusionData } = await supabase.from('group_member_exclusions').select('*').eq('household_id', id);
      setExclusions(exclusionData || []);

      const { data: guestData } = await supabase.from('group_guests').select('*').eq('household_id', id);
      setGuests(guestData || []);

      const { data: memberRecords } = await supabase.from('household_members').select('user_id').eq('household_id', id);
      const memberIdsFromTable = (memberRecords || []).map(m => m.user_id);

      const { data: txs } = await supabase
        .from('transactions')
        .select('*')
        .eq('household_id', id)
        .order('date', { ascending: false });

      const txList = (txs || []) as Transaction[];
      setAllTransactions(txList);

      const usersInTransactions = Array.from(new Set(txList.map(t => t.user_id)));
      const combinedMemberIds = Array.from(new Set([...memberIdsFromTable, ...usersInTransactions]));
      setMemberIds(combinedMemberIds);

      const { data: profiles } = await supabase.from('user_profiles').select('id, display_name').in('id', combinedMemberIds);
      const names: Record<string, string> = {};
      profiles?.forEach(p => { names[p.id] = p.display_name || 'Member'; });
      combinedMemberIds.forEach(uid => { if (!names[uid]) names[uid] = `User ${uid.substring(0, 4)}`; });
      
      guestData?.forEach(g => { names[g.id] = g.name; });
      setUserMap(names);
      
    } catch (e) {
      console.error("Fetch Data Error:", e);
    } finally {
      setLoading(false);
    }
  };

  const addGuest = async () => {
    if (!newGuestName.trim() || !id) return;
    const { data, error } = await supabase.from('group_guests').insert([{ household_id: id, name: newGuestName.trim() }]).select().single();
    if (!error && data) {
      setGuests([...guests, data]);
      setUserMap({ ...userMap, [data.id]: data.name });
      setNewGuestName('');
      await fetchData();
    }
  };

  const removeGuest = async (guestId: string) => {
    const guest = guests.find(g => g.id === guestId);
    if (!window.confirm(`Permanently remove "${guest?.name}"? Their financial history will be marked as 'Unassigned' but group totals will remain accurate.`)) return;
    
    const { error } = await supabase.from('group_guests').delete().eq('id', guestId);
    if (!error) {
      await fetchData();
    } else {
      alert("Removal failed: " + error.message);
    }
  };

  const toggleParticipation = async (memberId: string) => {
    const { data: { user } } = await supabase.auth.getUser();
    const isAdmin = user?.id === group?.created_by;
    const isSelf = user?.id === memberId;
    
    if (!isAdmin && !isSelf) {
      alert("Admin authorization required to toggle other members.");
      return;
    }

    const existingIndex = exclusions.findIndex(e => e.excluded_id === memberId && e.month === selectedMonth);

    if (existingIndex > -1) {
      const exclusionId = exclusions[existingIndex].id;
      const { error } = await supabase.from('group_member_exclusions').delete().eq('id', exclusionId);
      if (!error) {
        setExclusions(prev => prev.filter(e => e.id !== exclusionId));
      }
    } else {
      const { data, error } = await supabase.from('group_member_exclusions').insert([{
        household_id: id,
        excluded_id: memberId,
        month: selectedMonth
      }]).select().single();
      if (!error && data) {
        setExclusions(prev => [...prev, data]);
      }
    }
  };

  const filteredTransactions = useMemo(() => {
    if (isAllTime) return allTransactions;
    const start = startOfMonth(new Date(selectedMonth + '-01'));
    const end = endOfMonth(new Date(selectedMonth + '-01'));
    return allTransactions.filter(t => {
      const txDate = new Date(t.date);
      return isWithinInterval(txDate, { start, end });
    });
  }, [allTransactions, selectedMonth, isAllTime]);

  const stats = useMemo(() => {
    // Helper function to calculate settlements for a set of transactions and exclusions
    const computeStats = (txs: Transaction[], monthKey: string | null): MonthlyBreakdown => {
      let total = 0;
      const currentMonthExclusions = monthKey 
        ? exclusions.filter(e => e.month === monthKey).map(e => e.excluded_id) 
        : [];

      const allPayerIds = Array.from(new Set([
        ...memberIds,
        ...guests.map(g => g.id)
      ]));

      const participatingPayerIds = allPayerIds.filter(pid => isAllTime || !currentMonthExclusions.includes(pid));
      
      const contributions: Record<string, number> = {};
      allPayerIds.forEach(pid => contributions[pid] = 0);
      
      txs.forEach(t => {
        if (t.type === 'expense' || t.type === 'debt') {
          const amount = Number(t.amount);
          total += amount;
          const payerId = t.payer_guest_id || t.user_id;
          if (payerId) {
            contributions[payerId] = (contributions[payerId] || 0) + amount;
          }
        }
      });

      const share = participatingPayerIds.length > 0 ? total / participatingPayerIds.length : 0;
      
      const balances = allPayerIds.map(pid => {
        const isExcluded = monthKey && !isAllTime && currentMonthExclusions.includes(pid);
        return {
          pid,
          name: userMap[pid] || 'Unassigned Member',
          balance: isExcluded ? 0 : (contributions[pid] || 0) - share,
          isExcluded
        };
      });

      const creditors = balances.filter(b => b.balance > 0.01).sort((a, b) => b.balance - a.balance);
      const debtors = balances.filter(b => b.balance < -0.01).sort((a, b) => a.balance - b.balance);

      const settlements: Settlement[] = [];
      let i = 0, j = 0;
      const creditorsCopy = creditors.map(c => ({ ...c }));
      const debtorsCopy = debtors.map(d => ({ ...d }));

      while (i < debtorsCopy.length && j < creditorsCopy.length) {
        const debtAmount = Math.abs(debtorsCopy[i].balance);
        const creditAmount = creditorsCopy[j].balance;
        const settlementAmount = Math.min(debtAmount, creditAmount);
        
        if (settlementAmount > 0.01) {
          settlements.push({
            from: debtorsCopy[i].name,
            to: creditorsCopy[j].name,
            amount: Math.round(settlementAmount * 100) / 100
          });
        }
        
        debtorsCopy[i].balance += settlementAmount;
        creditorsCopy[j].balance -= settlementAmount;
        if (Math.abs(debtorsCopy[i].balance) < 0.01) i++;
        if (Math.abs(creditorsCopy[j].balance) < 0.01) j++;
      }

      return {
        total,
        contributions,
        settlements,
        share,
        participatingCount: participatingPayerIds.length,
        currentMonthExclusions,
        monthKey,
        allPayerIds
      };
    };

    if (!isAllTime) {
      const current = computeStats(filteredTransactions, selectedMonth);
      return { 
        ...current, 
        allPayerIds: Array.from(new Set([...memberIds, ...guests.map(g => g.id)])),
        monthlyBreakdowns: [] as MonthlyBreakdown[]
      };
    } else {
      // Group transactions by month
      const monthsMap: Record<string, Transaction[]> = {};
      allTransactions.forEach(tx => {
        const mKey = format(new Date(tx.date), 'yyyy-MM');
        if (!monthsMap[mKey]) monthsMap[mKey] = [];
        monthsMap[mKey].push(tx);
      });

      const breakdowns: MonthlyBreakdown[] = Object.keys(monthsMap)
        .sort((a, b) => b.localeCompare(a)) // Latest month first
        .map(mKey => computeStats(monthsMap[mKey], mKey));

      const overallTotal = allTransactions.reduce((acc, t) => acc + (t.type === 'expense' || t.type === 'debt' ? Number(t.amount) : 0), 0);
      const aggregateContributions: Record<string, number> = {};
      const allPayerIds = Array.from(new Set([...memberIds, ...guests.map(g => g.id)]));
      allPayerIds.forEach(pid => aggregateContributions[pid] = 0);
      allTransactions.forEach(t => {
        if (t.type === 'expense' || t.type === 'debt') {
          const payerId = t.payer_guest_id || t.user_id;
          if (payerId) {
            aggregateContributions[payerId] = (aggregateContributions[payerId] || 0) + Number(t.amount);
          }
        }
      });

      return { 
        total: overallTotal, 
        allPayerIds,
        monthlyBreakdowns: breakdowns,
        settlements: [], // Not used at top level in All Time
        contributions: aggregateContributions, 
        share: overallTotal / (allPayerIds.length || 1), // Average share for orientation
        participatingCount: allPayerIds.length,
        currentMonthExclusions: [] as string[]
      };
    }
  }, [filteredTransactions, allTransactions, memberIds, guests, userMap, exclusions, selectedMonth, isAllTime]);

  if (loading) return <div className="pt-20 text-center"><div className="animate-spin h-10 w-10 border-b-2 border-slate-900 mx-auto rounded-full"></div></div>;

  return (
    <div className="space-y-6 pb-20">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
        <div className="flex items-center gap-4">
          <button onClick={() => navigate('/groups')} className="p-3 bg-white border border-slate-100 rounded-2xl text-slate-400 hover:text-slate-900 shadow-sm transition-all"><ChevronLeft size={20} /></button>
          <div>
            <h1 className="text-2xl font-black text-slate-900 leading-none">{group?.name}</h1>
            <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mt-2">Group Overview</p>
          </div>
        </div>
        <div className="flex gap-3">
          <button onClick={() => setShowGuestManager(!showGuestManager)} className={`flex-1 md:flex-none p-4 rounded-2xl border transition-all flex items-center justify-center gap-2 ${showGuestManager ? 'bg-[#0f172a] text-[#fbbf24]' : 'bg-white text-slate-600 border-slate-100'}`}>
            <UserCircle size={18} />
            <span className="font-black text-[10px] uppercase tracking-widest">Extra People</span>
          </button>
          <button 
            onClick={async () => {
              const doc = generateGroupSettlementPDF(group!.name, stats.total, stats.participatingCount, stats.contributions, userMap, stats.settlements, filteredTransactions, selectedMonth, isAllTime, stats.monthlyBreakdowns);
              await saveSecurePDF(doc, `Settlement_Report_${group!.name.replace(/\s/g, '_')}.pdf`, userPin || undefined, {
                selectedMonth,
                householdId: id,
                exportMode: isAllTime ? 'custom' : 'monthly'
              });
            }} 
            className="flex-1 md:flex-none bg-[#0f172a] text-[#fbbf24] p-4 rounded-2xl shadow-lg flex items-center justify-center gap-2 border border-white/5"
          >
            <FileText size={18} />
            <span className="font-black text-[10px] uppercase tracking-widest">Report</span>
          </button>
        </div>
      </div>

      {showGuestManager && (
        <div className="bg-white p-8 rounded-[3rem] border-2 border-slate-100 shadow-2xl animate-in slide-in-from-top duration-300">
           <h3 className="text-xs font-black text-slate-900 uppercase tracking-widest mb-6 flex items-center"><Users className="mr-2 text-amber-500" size={16} /> People In This Group</h3>
           <div className="space-y-4">
              <div className="flex flex-col sm:flex-row gap-3">
                <input type="text" placeholder="Alias (e.g. Person C)" className="flex-1 px-6 py-4 bg-slate-50 border border-slate-100 rounded-2xl outline-none font-bold text-sm" value={newGuestName} onChange={e => setNewGuestName(e.target.value)} />
                <button onClick={addGuest} className="bg-[#0f172a] text-amber-400 px-6 py-4 sm:py-0 rounded-2xl font-black text-[10px] uppercase tracking-widest flex items-center justify-center gap-2 transition-all active:scale-95"><Plus size={16} /> Add Person</button>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-4">
                {guests.map(g => (
                  <div key={g.id} className="flex items-center justify-between p-4 bg-slate-50 rounded-2xl border border-slate-100 group hover:border-slate-300 transition-all">
                    <span className="font-bold text-slate-700 text-sm">{g.name}</span>
                    <button 
                      onClick={() => removeGuest(g.id)} 
                      className="text-slate-300 hover:text-red-500 hover:bg-red-50 p-2.5 rounded-xl transition-all"
                      title="Remove Member"
                    >
                      <Trash2 size={16} />
                    </button>
                  </div>
                ))}
                {guests.length === 0 && (
                  <div className="col-span-2 py-8 text-center bg-slate-50/50 rounded-3xl border border-dashed border-slate-200">
                    <p className="text-[9px] font-black text-slate-300 uppercase tracking-widest">No extra people added</p>
                  </div>
                )}
              </div>
           </div>
           <div className="mt-6 flex items-center gap-3 bg-amber-50 p-4 rounded-2xl border border-amber-100">
              <AlertTriangle className="text-amber-600 shrink-0" size={16} />
              <p className="text-[9px] font-bold text-amber-700 uppercase tracking-wider leading-relaxed">
                Deleting a member recalculates the "Fair Share" for the remaining group. Any payments they made will be kept but unassigned.
              </p>
           </div>
        </div>
      )}

      <div className="bg-white p-4 rounded-[2rem] border border-slate-100 shadow-sm flex flex-col sm:flex-row items-center gap-4">
        <div className="flex items-center gap-3 bg-slate-50 p-1.5 rounded-2xl border border-slate-100 flex-1 w-full">
          <button onClick={() => setIsAllTime(false)} className={`flex-1 py-2.5 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${!isAllTime ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-400'}`}>Monthly</button>
          <button onClick={() => setIsAllTime(true)} className={`flex-1 py-2.5 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${isAllTime ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-400'}`}>All Time</button>
        </div>
        {!isAllTime && (
          <div className="relative w-full sm:w-64">
            <Calendar className="absolute left-5 top-1/2 -translate-y-1/2 text-slate-300" size={16} />
            <select value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)} className="w-full pl-12 pr-6 py-4 bg-slate-50 border border-slate-100 rounded-2xl outline-none font-black text-[10px] uppercase tracking-widest appearance-none cursor-pointer">
              {Array.from({ length: 12 }).map((_, i) => { 
                const d = subMonths(new Date(), i); 
                return <option key={i} value={format(d, 'yyyy-MM')}>{format(d, 'MMMM yyyy')}</option>; 
              })}
            </select>
          </div>
        )}
      </div>

      <div className="bg-[#0f172a] p-8 rounded-[3rem] text-white shadow-2xl relative overflow-hidden border border-white/5">
        <div className="absolute top-0 right-0 w-48 h-48 bg-amber-400/10 blur-[60px] -translate-y-1/2 translate-x-1/2"></div>
        <div className="relative z-10 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div className="flex flex-col gap-1">
            <p className="text-[10px] font-black uppercase opacity-60 tracking-[0.2em]">{isAllTime ? 'Total Group Spend' : `Spend for ${format(new Date(selectedMonth + '-01'), 'MMMM yyyy')}`}</p>
            <p className="text-3xl sm:text-4xl font-black text-amber-400 mt-2 break-all">₹{stats.total.toLocaleString()}</p>
            <div className="mt-4 flex flex-wrap gap-4">
               <div className="flex items-center gap-2 bg-white/5 px-3 py-1.5 rounded-xl border border-white/5"><Users size={12} className="text-slate-400" /><span className="text-[9px] font-bold text-slate-400 uppercase tracking-widest">{stats.participatingCount} In Split / {stats.allPayerIds.length} Total</span></div>
               <div className="flex items-center gap-2 bg-amber-400/10 px-3 py-1.5 rounded-xl border border-amber-400/10"><Scale size={12} className="text-amber-400" /><span className="text-[9px] font-black text-amber-400 uppercase tracking-widest">Fair Share: ₹{Math.round(stats.share).toLocaleString()}</span></div>
            </div>
          </div>
        </div>
      </div>

      <section className="space-y-4">
        <h3 className="text-xs font-black text-slate-900 uppercase tracking-widest flex items-center px-2"><Filter size={14} className="mr-2 text-slate-400" /> Who Paid And Split</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {stats.allPayerIds.map((pid) => {
            const amount = stats.contributions[pid] || 0;
            const isExcluded = stats.currentMonthExclusions?.includes(pid);
            const balance = isExcluded ? 0 : amount - stats.share;
            
            return (
              <div key={pid} className={`bg-white p-6 rounded-[2rem] border transition-all ${isExcluded ? 'border-slate-100 opacity-50' : 'border-slate-100 shadow-sm hover:border-slate-300'}`}>
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center">
                    <div className="w-10 h-10 rounded-2xl bg-slate-50 flex items-center justify-center mr-4">
                      {isExcluded ? <UserX size={18} className="text-slate-300" /> : <UserIcon size={18} className="text-[#0f172a]" />}
                    </div>
                    <div>
                      <p className="font-black text-slate-900 text-xs">{userMap[pid]}</p>
                      <p className="text-[8px] font-black text-slate-400 uppercase tracking-widest">Paid: ₹{amount.toLocaleString()}</p>
                    </div>
                  </div>
                  {!isAllTime && (
                    <button 
                      onClick={() => toggleParticipation(pid)}
                      className={`flex items-center gap-2 px-4 py-2.5 rounded-xl transition-all shadow-sm ${isExcluded ? 'bg-slate-100 text-slate-400' : 'bg-amber-100 text-amber-700 font-bold'}`}
                      title={isExcluded ? "Include in this month's split" : "Exclude from this month's split"}
                    >
                      <span className="text-[10px] font-black uppercase tracking-widest">{isExcluded ? 'Excluded' : 'Included'}</span>
                      {isExcluded ? <ToggleOff size={20} /> : <ToggleOn size={20} />}
                    </button>
                  )}
                </div>
                <div className="flex justify-between items-center bg-slate-50/50 p-4 rounded-2xl">
                  <p className="text-[7px] font-bold text-slate-400 uppercase tracking-widest">Calculated Balance</p>
                  <p className={`font-black text-xs ${isExcluded ? 'text-slate-400' : (balance >= 0 ? 'text-emerald-600' : 'text-red-600')}`}>
                    {balance === 0 ? '₹0' : (balance >= 0 ? '+' : '-') + '₹' + Math.abs(balance).toLocaleString()}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="space-y-4">
        <h3 className="text-xs font-black text-slate-900 uppercase tracking-widest flex items-center px-2"><Scale size={14} className="mr-2 text-amber-500" /> Who Owes Who</h3>
        
        {isAllTime ? (
          <div className="space-y-8 relative before:absolute before:left-[1.35rem] before:top-4 before:bottom-4 before:w-0.5 before:bg-slate-100 before:border-dashed before:border-slate-200">
            {stats.monthlyBreakdowns.map((breakdown, bIdx) => {
              const monthColors = [
                { border: 'border-l-indigo-500', text: 'text-indigo-600', bg: 'bg-indigo-50/50' },
                { border: 'border-l-amber-500', text: 'text-amber-600', bg: 'bg-amber-50/50' },
                { border: 'border-l-emerald-500', text: 'text-emerald-600', bg: 'bg-emerald-50/50' },
                { border: 'border-l-rose-500', text: 'text-rose-600', bg: 'bg-rose-50/50' },
                { border: 'border-l-sky-500', text: 'text-sky-600', bg: 'bg-sky-50/50' }
              ];
              const color = monthColors[bIdx % monthColors.length];
              
              return (
                <div key={bIdx} className={`relative ml-4 pl-8 transition-all group hover:translate-x-1 duration-300`}>
                  {/* Timeline Dot */}
                  <div className={`absolute left-[-1.15rem] top-1 w-4 h-4 rounded-full border-4 border-white shadow-md ${color.border.replace('border-l-', 'bg-')} z-10 animate-in zoom-in`}></div>
                  
                  <div className={`bg-white rounded-[2.5rem] border ${color.border} border-l-8 p-6 shadow-xl hover:shadow-2xl transition-all border-slate-100`}>
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6 gap-3">
                      <div className={`inline-flex items-center gap-2 px-6 py-2.5 rounded-2xl ${color.bg} ${color.text} shadow-sm`}>
                        <Calendar size={14} />
                        <h4 className="text-[11px] font-black uppercase tracking-[0.2em]">{format(new Date(breakdown.monthKey + '-01'), 'MMMM yyyy')}</h4>
                      </div>
                      <div className="flex items-center gap-2 px-4 py-2 bg-slate-50 border border-slate-100 rounded-xl">
                        <span className="text-[8px] font-black text-slate-400 uppercase tracking-widest">Monthly Flow</span>
                        <span className="text-[10px] font-black text-slate-700">INR {breakdown.total.toLocaleString()}</span>
                      </div>
                    </div>

                    <div className="mb-6 flex flex-wrap items-center gap-2">
                      <div className="flex items-center gap-2 px-4 py-2 bg-amber-50 border border-amber-100 rounded-xl">
                        <span className="text-[8px] font-black text-amber-700 uppercase tracking-widest">Fair Share</span>
                        <span className="text-[10px] font-black text-amber-700">INR {Math.round(breakdown.share).toLocaleString()}</span>
                      </div>
                      <div className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-100 rounded-xl">
                        <span className="text-[8px] font-black text-slate-400 uppercase tracking-widest">People In Split</span>
                        <span className="text-[10px] font-black text-slate-700">{breakdown.participatingCount}</span>
                      </div>
                    </div>

                    <div className="mb-6">
                      <div className="flex items-center justify-between mb-3">
                        <p className="text-[8px] font-black text-slate-400 uppercase tracking-[0.2em]">Who Paid This Month</p>
                        <p className="text-[8px] font-black text-slate-300 uppercase tracking-[0.2em]">Paid and balance</p>
                      </div>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {breakdown.allPayerIds.map((pid) => {
                          const paid = breakdown.contributions[pid] || 0;
                          const isExcluded = breakdown.currentMonthExclusions.includes(pid);
                          const net = isExcluded ? 0 : paid - breakdown.share;

                          return (
                            <div key={`${breakdown.monthKey}-${pid}`} className={`rounded-2xl border p-4 ${isExcluded ? 'bg-slate-50 border-slate-100 opacity-70' : 'bg-white border-slate-100 shadow-sm'}`}>
                              <div className="flex items-start justify-between gap-3">
                                <div>
                                  <p className="font-black text-slate-900 text-xs">{userMap[pid] || 'Unassigned Member'}</p>
                                  <p className="text-[8px] font-black text-slate-400 uppercase tracking-widest mt-1">
                                    {isExcluded ? 'Not in split this month' : 'Included in split'}
                                  </p>
                                </div>
                                <div className={`px-3 py-1 rounded-xl text-[8px] font-black uppercase tracking-widest ${isExcluded ? 'bg-slate-100 text-slate-400' : `${color.bg} ${color.text}`}`}>
                                  Paid INR {paid.toLocaleString()}
                                </div>
                              </div>
                              <div className="mt-3 flex items-center justify-between rounded-xl bg-slate-50 px-3 py-2">
                                <span className="text-[8px] font-black text-slate-400 uppercase tracking-widest">Balance vs fair share</span>
                                <span className={`text-[10px] font-black ${isExcluded ? 'text-slate-400' : (net >= 0 ? 'text-emerald-600' : 'text-red-600')}`}>
                                  {net === 0 ? 'INR 0' : `${net > 0 ? '+' : '-'}INR ${Math.abs(net).toLocaleString()}`}
                                </span>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    <div className="space-y-3">
                      {breakdown.settlements.length > 0 ? (
                        breakdown.settlements.map((s, idx) => (
                          <div key={idx} className="flex flex-col sm:flex-row items-center justify-between p-5 bg-slate-50/50 rounded-2xl border border-slate-100/50 group-hover:bg-white transition-colors">
                            <div className="flex items-center gap-4 mb-3 sm:mb-0">
                              <div className="px-4 py-2 bg-white rounded-xl shadow-sm border border-slate-100">
                                <span className="font-black text-slate-900 text-xs">{s.from}</span>
                              </div>
                              <div className="flex flex-col items-center">
                                <ArrowRight size={16} className={`${color.text} animate-pulse`} />
                                <span className={`text-[6px] font-bold uppercase tracking-tighter ${color.text}`}>Transfer</span>
                              </div>
                              <div className="px-4 py-2 bg-white rounded-xl shadow-sm border border-slate-100">
                                <span className="font-black text-slate-900 text-xs">{s.to}</span>
                              </div>
                            </div>
                            <div className="flex flex-col items-end">
                              <span className="text-[7px] font-black text-slate-400 uppercase tracking-widest mb-1">Transfer Amount</span>
                              <p className={`font-black text-lg ${color.text}`}>₹{s.amount.toLocaleString()}</p>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center py-6 border-2 border-dashed border-slate-100 rounded-[2rem]">
                          <ShieldCheck size={24} className="text-emerald-400 mx-auto mb-2 opacity-50" />
                          <p className="text-[9px] font-black text-slate-300 uppercase tracking-widest">Everyone is settled</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
            {stats.monthlyBreakdowns.length === 0 && (
              <div className="bg-slate-50 rounded-[2.5rem] border border-dashed border-slate-200 p-12 text-center ml-4">
                <Clock size={32} className="text-slate-200 mx-auto mb-4" />
                <p className="text-[10px] font-black text-slate-400 uppercase tracking-[0.3em]">No past data found</p>
              </div>
            )}
          </div>
        ) : (
          <div className="bg-amber-50/50 rounded-[2.5rem] border border-amber-100 p-10 space-y-4">
            {stats.settlements.length > 0 ? (
              stats.settlements.map((s, idx) => (
                <div key={idx} className="bg-white p-6 rounded-[2rem] border border-amber-100 flex items-center justify-between shadow-xl animate-in slide-in-from-bottom duration-500" style={{ animationDelay: `${idx * 100}ms` }}>
                  <div className="flex items-center gap-6">
                    <div className="text-center">
                      <p className="font-black text-slate-900 text-sm mb-1">{s.from}</p>
                      <div className="px-2 py-0.5 bg-red-50 rounded-lg"><p className="text-[7px] font-black text-red-500 uppercase tracking-widest">Owes</p></div>
                    </div>
                    <div className="flex flex-col items-center">
                      <ArrowRight size={18} className="text-amber-400" />
                      <div className="w-8 h-0.5 bg-amber-100 rounded-full mt-1"></div>
                    </div>
                    <div className="text-center">
                      <p className="font-black text-slate-900 text-sm mb-1">{s.to}</p>
                      <div className="px-2 py-0.5 bg-emerald-50 rounded-lg"><p className="text-[7px] font-black text-emerald-600 uppercase tracking-widest">To Collect</p></div>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-[8px] font-black text-slate-400 uppercase tracking-widest mb-1">Settlement</p>
                    <p className="font-black text-amber-600 text-2xl tracking-tighter">₹{s.amount.toLocaleString()}</p>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center py-20 bg-white/50 rounded-[2rem] border-2 border-dashed border-amber-100">
                <ShieldCheck size={40} className="text-emerald-500 mx-auto mb-6 opacity-40" />
                <p className="text-xs font-black text-emerald-800 uppercase tracking-[0.3em] leading-relaxed">Everyone Is Settled<br />For This Period</p>
              </div>
            )}
          </div>
        )}
      </section>

      <section className="space-y-4">
        <h3 className="text-xs font-black text-slate-900 uppercase tracking-widest flex items-center px-2"><Clock size={14} className="mr-2 text-slate-400" /> Transactions</h3>
        <div className="space-y-3">
          {filteredTransactions.map(tx => (
            <div key={tx.id} onClick={() => navigate(`/edit/${tx.id}`)} className="bg-white p-5 rounded-[2rem] border border-slate-100 flex items-center justify-between group transition-all hover:border-slate-300 cursor-pointer active:scale-[0.99]">
              <div className="flex items-center">
                <div className={`w-12 h-12 rounded-2xl flex items-center justify-center mr-4 ${tx.type === 'expense' || tx.type === 'debt' ? 'bg-red-50 text-red-500' : 'bg-emerald-50 text-emerald-600'}`}>
                  {tx.type === 'expense' || tx.type === 'debt' ? <ArrowDownRight size={20} /> : <ArrowUpRight size={20} />}
                </div>
                <div>
                  <p className="font-black text-slate-900 text-sm leading-tight">{tx.category}</p>
                  <p className="text-[9px] text-slate-400 font-black uppercase tracking-widest mt-1">
                    {userMap[tx.payer_guest_id || tx.user_id] || 'Member'} • {format(new Date(tx.date), 'dd MMM')}
                  </p>
                </div>
              </div>
              <p className={`font-black text-base ${tx.type === 'expense' || tx.type === 'debt' ? 'text-red-600' : 'text-emerald-700'}`}>
                ₹{Number(tx.amount).toLocaleString()}
              </p>
            </div>
          ))}
          {filteredTransactions.length === 0 && (
            <div className="text-center py-10 bg-white rounded-[2rem] border border-dashed border-slate-200">
               <p className="text-[9px] font-black text-slate-300 uppercase tracking-widest">No group entries for this period</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default GroupDetail;
